export default "__VITE_ASSET__BS9kFE7g__"